module.exports = __webpack_public_path__ + "img/sandra-alt.74ab060f.png";